/**
 * Tipos de autenticação e autorização
 * Define a estrutura de dados para JWT, usuários e roles
 */

export enum UserRole {
  ADMIN = 'ADMIN',
  DOCTOR = 'DOCTOR',
  PATIENT = 'PATIENT',
}

export type UserDTO = {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
};

export type JWTPayload = {
  sub: string; // User ID
  email: string;
  name: string;
  role: UserRole;
  iat: number; // Issued at
  exp: number; // Expiration
};

export type LoginRequestDTO = {
  email: string;
  password: string;
};

export type LoginResponseDTO = {
  user: UserDTO;
  accessToken: string;
  refreshToken?: string;
};

export type RegisterRequestDTO = {
  email: string;
  password: string;
  name: string;
  role?: UserRole;
  /** Número do CRM — obrigatório quando role=DOCTOR */
  crm?: string;
  /** UF do CRM — obrigatório quando role=DOCTOR */
  crmState?: string;
};

export type AuthContextType = {
  user: UserDTO | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  register: (data: RegisterRequestDTO) => Promise<void>;
};
